import axios from "axios";
import config from "../config";
import { SearchResponse } from "./ResponseModels/SearchResponse";
import SearchResponseFakeJson from "./json/SearchResponseFake.json";
import { FakeAxiosResponse } from "./FakeAxiosResponse";

export async function GetSearchWoModel(
  keyword: string,
  contentType: string,
  channelIds: string,
  pageSize: number,
  page: number
) {
  let response = null;
  if (!config.useFakeModels) {
    response = axios
      .get<SearchResponse>(config.getSearchEndpoint, {
        params: {
          keyword: keyword,
          content_type: contentType,
          channelIds: channelIds,
          pageSize: pageSize,
          page: page,
        },
      })
      .catch((e) => {
        // TODO manage
        console.error("There was an error!", e);
      });
  } else {
    const responseData = JSON.parse(JSON.stringify(SearchResponseFakeJson));

    response = FakeAxiosResponse(responseData, 200);
  }

  return response;
}
